var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 1",
    clipPath: "url(#clip0_311_453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.3333 24.9167V11.258L22.1667 23.8333V41.1667H17.8333V4.33333H20V0H0.5V4.33333H2.66667V45.5C2.66667 49.0837 5.583 52 9.16667 52H46C49.5837 52 52.5 49.0837 52.5 45.5V11.258L37.3333 24.9167ZM35.1667 41.1667H28.6667V34.6667H35.1667V41.1667ZM46 41.1667H39.5V34.6667H46V41.1667Z",
    fill: "#e88d78"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.3c16a1f489b6c1d5aecc2b90dbc37c83.svg";
export { ForwardRef as ReactComponent };